import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import { Switch } from '@this/shared/ui/inputs/switch';
import { type PreferredTransportType } from '../../../types/proposalBundles';

type Props = {
  value: PreferredTransportType;
  onChange: (value: PreferredTransportType) => void;
  disabled?: boolean;
};

export const TransportTypeToggle = ({ value, onChange, disabled = false }: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  const handleToggle = (checked: boolean) => {
    onChange(checked ? 'air' : 'rail');
  };
  const railActive = value === 'rail';
  const airActive = value === 'air';

  return (
    <div style={styles.container}>
      <span style={railActive ? styles.iconActive : styles.icon}>
        <img src="/images/train.png" alt="train" style={styles.iconImage} />
      </span>
      <Switch checked={airActive} onChange={handleToggle} disabled={disabled} />
      <span style={airActive ? styles.iconActive : styles.icon}>
        <img src="/images/plane.png" alt="flight" style={styles.iconImage} />
      </span>
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    color: theme.textColor
  },
  icon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    opacity: 0.5
  },
  iconActive: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    opacity: 1
  },
  iconImage: {
    width: '16px',
    height: '16px'
  }
});
